<template>
  <div>
    <div class="page-heading">
      <h2>
        {{ $I18n.t('disponibilidad_para_guardias') }}
        <a
          href="/eventos"
          class="btn btn-sm btn-default pull-right"
        >
          <i class="fa fa-calendar-alt"></i> {{ $I18n.t('Agenda') }}
        </a>
        <a
          v-if="accesoGuardias"
          href="/guardias/guardias"
          class="btn btn-sm btn-default pull-right m-r-xs"
        >
          <i class="fa fa-calendar-day"></i> {{ $I18n.t('guardias') }}
        </a>
      </h2>
    </div>
    <calendario
      ref="calendario"
      class="calendario-disponibilidad m-t"
      :puede-anadir="editable"
      :slot-todo-el-dia="false"
      :event-source="eventSource"
      @event-render="eventRender"
      @event-new="eventNew"
      @event-click="eventShow"
      @event-moved="eventMoved"
      @dates-selected="eventNew($event.start, $event.end)"
    />
    <ModalSimple
      id="modal-disponibilidad"
      v-model="showModal"
    >
      <form-disponibilidad
        v-if="showModal"
        :disabled="!editable"
        :disponibilidad-id="disponibilidadFormularioId"
        :fecha-inicio-inicial="fechaInicio"
        :fecha-fin-inicial="fechaFin"
        :fecha-fin-repeticion-inicial="fechaFinRepeticion"
        @cancelado="cerrarModal"
        @guardado="cerrarModal"
        @eliminado="cerrarModal"
      />
    </ModalSimple>
  </div>
</template>

<script>

import ModalSimple from '@/components/ModalSimple.vue';
import disponibilidades, { URL_DISPONIBILIDAD } from '../../../api/cifra/guardias/disponibilidades';
import { showApiErrors } from '../../../libs/cifra/flash';
import { renderExtraData } from '../../../libs/cifra/fullcalendar';
import FormDisponibilidad from './FormDisponibilidad.vue';

export default {
  components: { FormDisponibilidad, ModalSimple },
  props: {
    annoLectivo: { type: Object, default: null },
    editable: { type: Boolean, default: false },
    // true si tiene permisos para acceder a las guardias
    accesoGuardias: { type: Boolean, default: false },
  },
  data() {
    return {
      eventSource: URL_DISPONIBILIDAD,
      disponibilidadFormularioId: null,
      fechaInicio: null,
      fechaFin: null,
      showModal: false,
    };
  },
  computed: {
    fechaFinRepeticion() {
      return this.annoLectivo ? new Date(this.annoLectivo.fecha_fin) : null;
    },
  },
  methods: {
    eventNew(fechaInicio, fechaFin) {
      if (!this.editable) return;

      this.disponibilidadFormularioId = null;
      this.fechaInicio = fechaInicio;
      this.fechaFin = fechaFin;
      this.showModal = true;
    },
    eventShow(info) {
      this.disponibilidadFormularioId = parseInt(info.event.id, 10);
      this.formReservaDisabled = !info.event.startEditable;
      this.fechaInicio = info.event.start;
      this.fechaFin = info.event.end;
      this.showModal = true;
    },
    eventMoved(info) {
      if (!this.editable) return;

      const { event } = info;
      const fechaFin = event.end;

      // FullCalendar always set end to null when allDay changes as you can see in the doc
      // No permitimos eventos de "todo el día"
      if (!fechaFin) {
        return;
      }
      disponibilidades.move({
        disponibilidad: {
          id: event.id,
          fecha_inicio: event.start,
          fecha_fin: fechaFin,
        },
      }).then((_result) => {
        this.getCalendar().refetchEvents();
        this.$toast.success(this.$I18n.t('guardado_correcto'));
      }).catch((result) => {
        showApiErrors(result);
        this.getCalendar().refetchEvents();
      });
    },
    cerrarModal() {
      this.showModal = false;
      this.getCalendar().refetchEvents();
    },
    eventRender(arg) {
      const { event } = arg;
      const extra = event.extendedProps;

      let { icon } = extra;
      let tooltip = `<div>${event.title}</div>`;
      if (extra.guardias?.length) {
        icon = 'clock';
        tooltip += `<div>${this.$I18n.t('n_guardias_asignadas', { count: extra.guardias.length})}</div>`;
      }
      renderExtraData(arg, { icon, tooltip });
    },
    getCalendar() {
      return this.$refs.calendario.getCalendar();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "../../../../assets/stylesheets/cifra/vars/main.scss";

  #modal-disponibilidad {
    :deep(.vm--modal) {
      overflow: visible;
    }
  }

  // Este css es para que no muestre la hora, que centre
  // vertical y horizontalmente el texto etc.
  .calendario-disponibilidad :deep() {
    .fc {
      .fc-timegrid-slot-minor {
        border-top: none;
      }
      .fc-event-time {
        display: none;
      }
      .fc-event-title {
        text-align: center;
      }
      .fc-event-main-frame {
        align-items: center;
      }
      .fc-event-title-container {
        flex-grow: 0;
      }
    }
  }
</style>
